const ContentKey = 'content';
const MaxShownParagraphsKey = 'maxShownParagraphs';
export function makeViewOfDisplayProperties(displayField) {
    if (displayField.richContentOptions) {
        return {
            [ContentKey]: displayField.richContentOptions?.richContent,
            [MaxShownParagraphsKey]: displayField.richContentOptions?.maxShownParagraphs
        };
    }
    const pageNavigation = displayField.pageNavigationOptions;
    if (pageNavigation) {
        return {
            ...pageNavigation.submitText ? {
                submitText: pageNavigation.submitText
            } : {},
            ...pageNavigation.nextPageText ? {
                nextText: pageNavigation.nextPageText
            } : {},
            ...pageNavigation.previousPageText ? {
                previousText: pageNavigation.previousPageText
            } : {}
        };
    }
    return {};
}

//# sourceMappingURL=make-view-of-display-properties.js.map